"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ChevronRightIcon = ({ className, width = '24', height = '24', onClick, }) => {
    return (react_1.default.createElement("div", { onClick: onClick, role: onClick ? 'button' : undefined },
        react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, className: className, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M9 18L15 12L9 6", stroke: "#788598", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })))));
};
exports.default = ChevronRightIcon;
//# sourceMappingURL=ChevronRightIcon.js.map